import { useMutation } from "react-query";
import { ImportarConsumoUnidades } from "../typings/index";
import http from "infra/http";

function useImportarConsumoUnidades(id: string) {
  return useMutation(
    (data: ImportarConsumoUnidades) => {
      return http.post(`/v1/consumo/${id}/unidades`, data);
    },
    { retry: false }
  );
}

export default useImportarConsumoUnidades;
